/**
 * Bundle / subscription checkout via Draft Order (non-Plus).
 * Success URL shape: /checkouts/do/...  (NOT /checkouts/cn/...)
 */
(function () {
  'use strict';

  var LOG = '[Boostify DO]';

  if (window.__boostifyBundleCheckoutBound) {
    console.warn(LOG, 'SKIP — already bound (duplicate script load)');
    return;
  }
  window.__boostifyBundleCheckoutBound = true;
  console.log(LOG, 'LOADED', { href: location.href, ts: Date.now() });

  var ENDPOINT = '/apps/boostify/api/storefront/bundle-checkout';
  var inflight = false;
  var HOOKED = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function needsDraftCheckout(cart) {
    return (cart.items || []).some(function (item) {
      var p = item.properties || {};
      return !!(p._bundle || p._boostify_plan_id);
    });
  }

  /** Non-pack cart lines (e.g. single soap add-on) — must land on draft invoice. */
  function getExtraLineItems(cart) {
    return (cart.items || [])
      .filter(function (item) {
        var props = item.properties || {};
        return !props._bundle && !props._boostify_plan_id;
      })
      .map(function (item) {
        var qty = item.quantity || 1;
        var line = item.final_line_price != null ? item.final_line_price : item.line_price;
        var unitCents =
          line != null && qty > 0 ? Number(line) / qty : Number(item.price) || 0;
        var out = {
          variantId: String(item.variant_id || item.id),
          quantity: qty,
        };
        if (unitCents > 0) out.unitPrice = (unitCents / 100).toFixed(2);
        return out;
      });
  }

  function getBundleGroups(cart) {
    var groups = {};
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var bid = props._bundle || ('solo-' + (item.variant_id || item.id));
      if (!props._bundle && !props._boostify_plan_id) return;
      if (!groups[bid]) {
        groups[bid] = {
          id: bid,
          parentVariantId: props._bundle_parent_variant || String(item.variant_id || item.id),
          packPrice: props._bundle_price || '',
          title: props._bundle_title || props['חבילה'] || item.product_title || '',
          scents: [],
          attributes: [],
          isBundle: !!props._bundle,
        };
      }
      var g = groups[bid];
      if (props._bundle_parent_variant) g.parentVariantId = props._bundle_parent_variant;
      if (props._bundle_price) g.packPrice = props._bundle_price;
      if (props._bundle) {
        var slotKey = props._bundle_slot || '';
        var isFaceSlot = String(slotKey).indexOf('face') === 0;
        var faceAttrKey = '';
        if (isFaceSlot) {
          var faceIdxMatch = String(slotKey).match(/^face-?(\d+)$/i);
          faceAttrKey = faceIdxMatch ? 'סבון פנים ' + faceIdxMatch[1] : 'סבון פנים';
        }
        var scentTitle =
          (isFaceSlot
            ? props[faceAttrKey] || props['סבון פנים']
            : props['ריח ' + slotKey]) ||
          props['סבון פנים'] ||
          item.product_title ||
          item.title ||
          '';
        g.scents.push({
          variantId: String(item.variant_id || item.id),
          quantity: item.quantity || 1,
          title: scentTitle,
          slot: slotKey,
        });
      }
      Object.keys(props).forEach(function (key) {
        if (key === '_bundle' || key === '_bundle_slot' || key === '_bundle_image') return;
        if (
          key.indexOf('_boostify') === 0 ||
          key === 'מנוי' ||
          key === 'הנחה' ||
          key === 'תדירות' ||
          key.indexOf('ריח ') === 0 ||
          key === 'סבון פנים' ||
          key.indexOf('סבון פנים ') === 0 ||
          key === '_bundle_title' ||
          key === 'חבילה'
        ) {
          if (!g.attributes.some(function (a) { return a.key === key; })) {
            g.attributes.push({ key: key, value: String(props[key]) });
          }
        }
      });
    });
    return Object.keys(groups).map(function (k) { return groups[k]; });
  }

  async function fetchCart() {
    console.log(LOG, 'fetchCart…');
    var res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    var cart = await res.json();
    console.log(LOG, 'cart.js', {
      item_count: cart.item_count,
      items: (cart.items || []).map(function (i) {
        return {
          id: i.id,
          variant_id: i.variant_id,
          title: i.title,
          qty: i.quantity,
          properties: i.properties,
        };
      }),
    });
    return cart;
  }

  function detectCheckoutLocale() {
    var raw = '';
    try {
      if (window.Shopify && Shopify.locale) {
        raw = String(Shopify.locale).toLowerCase().replace(/_/g, '-');
      }
    } catch (_e) {}
    if (!raw) {
      raw = (document.documentElement.lang || '').toLowerCase().replace(/_/g, '-');
    }
    if (!raw) {
      var m = location.pathname.match(/\/([a-z]{2}(?:-[a-z0-9]+)?)(?:\/|$)/i);
      raw = (m && m[1]) || 'he-il';
    }
    if (raw === 'he' || raw === 'he-il') return 'he-il';
    return raw || 'he-il';
  }

  /** Draft invoiceUrl is EN/LTR by default. Never use locale=he — Shopify 302s /checkouts/do/.../he off checkout. */
  function withCheckoutLocale(invoiceUrl, locale) {
    var loc = detectCheckoutLocale();
    if (locale) {
      var asked = String(locale).trim().toLowerCase().replace(/_/g, '-');
      if (asked === 'he' || asked === 'he-il') loc = 'he-il';
      else if (/^[a-z]{2}(-[a-z0-9]+)?$/i.test(asked)) loc = asked;
    }
    try {
      var u = new URL(invoiceUrl, window.location.origin);
      u.pathname = u.pathname.replace(/\/(he|he-il|en|en-us|en-il)\/?$/i, '');

      if (/\/invoices\//i.test(u.pathname)) {
        u.searchParams.set('locale', loc === 'he-il' ? 'he-IL' : loc);
        return u.toString();
      }
      if (/\/checkouts\/(do|cn)\//i.test(u.pathname)) {
        if (new RegExp('/' + loc + '(/|$)', 'i').test(u.pathname)) return u.toString();
        u.pathname = u.pathname.replace(/\/+$/, '') + '/' + loc;
        return u.toString();
      }
      u.searchParams.set('locale', loc === 'he-il' ? 'he-IL' : loc);
      return u.toString();
    } catch (_e) {
      return invoiceUrl;
    }
  }

  async function createInvoice(group, currency, extraLineItems) {
    var locale = detectCheckoutLocale();
    var hasSubscription = (group.attributes || []).some(function (a) {
      return a && (a.key === '_boostify_plan_id' || a.key === '_boostify_recurring') && a.value;
    });
    var payload = {
      parentVariantId: group.parentVariantId,
      packPrice: group.packPrice,
      currencyCode: currency || 'ILS',
      locale: locale,
      hasSubscription: hasSubscription,
      title: group.title,
      scents: group.scents.length
        ? group.scents
        : [{ variantId: group.parentVariantId, quantity: 1, title: group.title, slot: '1' }],
      attributes: group.attributes,
      note: group.title || undefined,
    };
    if (extraLineItems && extraLineItems.length) {
      payload.extraLineItems = extraLineItems;
    }
    console.log(LOG, 'POST', ENDPOINT, payload);
    var res = await fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    var data = await res.json().catch(function () { return {}; });
    console.log(LOG, 'API status', res.status, data);
    if (!res.ok || !data.ok || !data.invoiceUrl) {
      throw new Error((data && (data.error || data.message)) || 'HTTP ' + res.status);
    }
    return withCheckoutLocale(data.invoiceUrl, locale);
  }

  function setBusy(busy) {
    document.querySelectorAll('[data-boostify-draft-checkout], [name="checkout"]').forEach(function (btn) {
      btn.disabled = !!busy;
      if (busy) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    });
  }

  function runDraftCheckout(event) {
    console.log(LOG, 'CLICK/SUBMIT intercepted', {
      type: event && event.type,
      target: event && event.target && (event.target.tagName + (event.target.className ? '.' + String(event.target.className).split(' ')[0] : '')),
      inflight: inflight,
    });
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      console.log(LOG, 'preventDefault + stopImmediatePropagation OK');
    }
    if (inflight) {
      console.warn(LOG, 'ignored — already inflight');
      return false;
    }
    inflight = true;
    setBusy(true);

    (async function () {
      try {
        var cart = await fetchCart();
        var needs = needsDraftCheckout(cart);
        console.log(LOG, 'needsDraftCheckout =', needs);
        if (!needs) {
          console.log(LOG, 'regular cart — native /checkout');
          inflight = false;
          setBusy(false);
          window.location.href = '/checkout';
          return;
        }
        var groups = getBundleGroups(cart);
        console.log(LOG, 'groups', groups);
        var group = groups[0];
        if (!group || !group.parentVariantId) {
          throw new Error('missing parentVariantId');
        }
        if (!group.packPrice) {
          var sum = 0;
          (cart.items || []).forEach(function (i) {
            if (!group.isBundle || (i.properties && i.properties._bundle === group.id)) {
              sum += (i.final_line_price || i.line_price || 0) / 100;
            }
          });
          group.packPrice = sum.toFixed(2);
          console.log(LOG, 'packPrice fallback', group.packPrice);
        }
        if (!group.scents.length && group.isBundle) {
          throw new Error('missing scent lines');
        }
        var extras = getExtraLineItems(cart);
        console.log(LOG, 'extraLineItems', extras);
        var invoiceUrl = await createInvoice(group, cart.currency || 'ILS', extras);
        console.log(LOG, 'invoiceUrl →', invoiceUrl);
        if (String(invoiceUrl).indexOf('/checkouts/cn/') !== -1) {
          console.error(LOG, 'BUG: invoiceUrl is cart checkout (cn), expected do');
        }
        // Do not clear the cart. Draft invoice does not need an empty cart.
        // /cart/clear.js ran even when assign was blocked → same PDP, empty cart.
        console.log(LOG, 'redirect →', invoiceUrl);
        window.location.href = invoiceUrl;
        // Safety: if navigation blocked, unlock checkout after 4s
        setTimeout(function () {
          inflight = false;
          setBusy(false);
        }, 4000);
      } catch (err) {
        console.error(LOG, 'FAILED', err && err.message ? err.message : err, err);
        alert('לא הצלחנו לפתוח תשלום למארז.\n' + (err && err.message ? err.message : ''));
        inflight = false;
        setBusy(false);
      }
    })();
    return false;
  }

  function hardenCheckoutControls(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('button[name="checkout"], button[type="submit"][name="checkout"], input[name="checkout"]');
    var hookedBtns = 0;
    buttons.forEach(function (btn) {
      if (HOOKED && HOOKED.has(btn)) return;
      if (!HOOKED && btn.getAttribute('data-boostify-draft-checkout') === '1') return;

      btn.setAttribute('data-boostify-draft-checkout', '1');
      btn.setAttribute('type', 'button');
      btn.removeAttribute('name');
      btn.addEventListener('click', runDraftCheckout, true);
      hookedBtns += 1;
      if (HOOKED) HOOKED.add(btn);
    });

    var hookedLinks = 0;
    scope.querySelectorAll('a[href="/checkout"], a[href$="/checkout"]').forEach(function (a) {
      if (HOOKED && HOOKED.has(a)) return;
      a.setAttribute('data-boostify-draft-checkout', '1');
      a.addEventListener(
        'click',
        function (e) {
          runDraftCheckout(e);
        },
        true
      );
      hookedLinks += 1;
      if (HOOKED) HOOKED.add(a);
    });

    if (hookedBtns || hookedLinks) {
      console.log(LOG, 'hardened', { buttons: hookedBtns, links: hookedLinks, scope: scope === document ? 'document' : scope.tagName });
    }
  }

  function bind() {
    console.log(LOG, 'bind()');
    hardenCheckoutControls(document);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1) hardenCheckoutControls(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var hit = form.querySelector('[data-boostify-draft-checkout], [name="checkout"]');
        if (hit) {
          console.log(LOG, 'form submit captured', form.id || form.getAttribute('action') || form.tagName);
          runDraftCheckout(e);
        } else {
          console.log(LOG, 'form submit ignored (no checkout control)', form.id || form.getAttribute('action'));
        }
      },
      true
    );

    console.log(LOG, 'ready — look for LOADED / harden / CLICK lines on checkout');
  }

  /** Wallet block calls this when cart has `_bundle` (wallet captures click first). */
  window.__boostifyGoToDraftCheckout = function () {
    console.log(LOG, 'called via __boostifyGoToDraftCheckout (from wallet)');
    return runDraftCheckout(null);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
